import { useState, useEffect } from "react";

export default function Hero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-[520px] md:min-h-[560px] bg-gradient-to-br from-[#f0f4ff] via-[#eef2ff] to-[#e8f0fe] overflow-hidden flex items-center">
      {/* 背景の装飾円 */}
      <div className="absolute top-[-120px] right-[-120px] w-[500px] h-[500px] rounded-full bg-gradient-to-br from-indigo-200/40 to-violet-200/30 blur-3xl pointer-events-none" />
      <div className="absolute bottom-[-80px] left-[-80px] w-[400px] h-[400px] rounded-full bg-gradient-to-tr from-blue-200/30 to-indigo-100/20 blur-3xl pointer-events-none" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 pt-20 md:pt-24 pb-12 md:pb-16">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-10 lg:gap-14">

          {/* ===== 左カラム: テキスト ===== */}
          <div
            className={`flex-1 text-left transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          >
            {/* ラベル */}
            <div className="mb-5">
              <span className="inline-flex items-center gap-2 bg-white border border-indigo-200 text-indigo-600 text-sm font-semibold rounded-full px-4 py-1.5 shadow-sm">
                <span className="text-yellow-400">✦</span>
                PoC開発支援
              </span>
            </div>

            {/* メインキャッチコピー */}
            <p className="text-sm md:text-base text-gray-500 mb-3 leading-relaxed font-medium">
              急な企画、最高のアイデア、全部弊社にお任せください。
            </p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight mb-5">
              “動く試作品”<span style={{fontSize: "3.75rem"}}>を</span>
              <br />
              最短翌日で
            </h2>

            {/* サブコピー */}
            <p className="text-lg md:text-xl text-gray-600 mb-7 leading-relaxed">
              翌日の夜には、モックを
              <span className="text-indigo-600 font-semibold">URLで送ります(無料）。<br />翌週にはPoCアプリを作ります。</span>
            </p>

            {/* CTAボタン */}
            <div className="flex flex-col sm:flex-row gap-4 items-start">
              <a
                href="#contact"
                className="inline-flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white font-bold px-7 py-4 rounded-xl transition-all duration-200 text-base whitespace-nowrap cursor-pointer hover:-translate-y-0.5"
              >
                <i className="ri-gift-line text-lg" />
                まずは無料でモック作成を依頼 →
              </a>
            </div>
          </div>

          {/* ===== 右カラム: ビジュアル ===== */}
          <div
            className={`flex-1 relative flex justify-center items-center w-full transition-all duration-700 delay-200 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
          >
            {/* YouTube埋め込み */}
            <div className="relative z-10 w-full max-w-2xl lg:max-w-xl aspect-video rounded-2xl overflow-hidden shadow-2xl border border-gray-200/80">
              <iframe
                src="https://www.youtube.com/embed/F_jrqLJoN-k?autoplay=1&mute=1"
                title="YouTube video player"
                aria-label="PoC開発支援サービス紹介動画"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="absolute inset-0 w-full h-full"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
